<template>
  <div v-show="isActive">
    <flash-message></flash-message>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'tab',

  props: {
    name: { required: true },
    info: { },
    selected: { default: false }
  },

  data() {
    return {
      isActive: false
    }
  },

  created() {
    this.isActive = this.selected
  }
}
</script>
